const routes = {
  path: "/contratos",
  name: "Contratos",
  component: () => import("./views/Contratos.vue"),
  meta: { requiresAuth: true },
  props: (route) => Object.assign({}, route.query, route.params),
};

export default routes;
